import { gql } from "@apollo/client";

export const CREATE_USER = gql`
  mutation CreateUser($input: UserInput!) {
    createUser(input: $input) {
      message {
        messageEn
        messageKh
      }
      status
    }
  }
`;

export const GET_USER_WITH_PAGINATION = gql`
  query GetUsersPagination(
    $page: Int
    $limit: Int
    $role: RoleEnum
    $keyword: String
    $isUse: Boolean
    $officeId: ID
  ) {
    getUsersPagination(
      page: $page
      limit: $limit
      role: $role
      keyword: $keyword
      isUse: $isUse
      officeId: $officeId
    ) {
      data {
        _id
        mainUserId {
          _id
          email
          firstName
          lastName
          latinName
          imageSrc
        }
        officeId {
          _id
          officeKhName
          officeEnName
        }
        isUse
        lastLogin
        role
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(_id: $id) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($id: ID!, $input: UserInput) {
    updateUser(_id: $id, input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const RESET_USER_PASSWORD = gql`
  mutation ResetPassword($id: ID!, $password: String!) {
    resetPassword(_id: $id, password: $password) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const VERIFY_LOGIN = gql`
  query VerifyLogin {
    verifyLogin {
      _id
      mainUserId {
        _id
        email
        firstName
        lastName
        latinName
        imageSrc
      }
      lastLogin
      role
    }
  }
`;
export const SELECT_MAIN_USER = gql`
  query SelectMainUser {
    selectMainUser {
      _id
      email
      firstName
      lastName
      latinName
      imageSrc
    }
  }
`;

export const USER_LOGIN = gql`
  mutation Login($password: String, $email: String) {
    login(password: $password, email: $email) {
      status
      message {
        messageEn
        messageKh
      }
      user {
        _id
        mainUserId {
          _id
          email
          firstName
          lastName
          latinName
          imageSrc
        }
        lastLogin
        role
      }
      token
    }
  }
`;

export const SELECT_USER = gql`
  query SelectUser {
    selectUser {
      _id
      mainUserId {
        _id
        email
        firstName
        lastName
        latinName
        imageSrc
      }
      officeId {
        officeKhName
        officeEnName
      }
      role
    }
  }
`;

export const UPDATE_USER_IS_USE = gql`
  mutation UpdateUserIsUse($id: ID!, $isUse: Boolean) {
    updateUserIsUse(_id: $id, isUse: $isUse) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const LOG_OUT = gql`
  mutation LogOut {
    logOut {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;
